import { createStyles, makeStyles } from '@material-ui/core/styles';

import { colorsPalette } from '../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    tooltip: {
      background: 'rgba(163, 163, 245, 1)',
      padding: '5px 10px',
      borderRadius: 3,
      color: colorsPalette.white,
      fontWeight: 'bold',
    },
  }),
);

export default useStyles;
